import axios from "axios";
import {toast} from "react-toastify";

export const FetchTranscripts = async (lesson) => {
    const transcriptUrl = lesson?.transcript;

    if (!transcriptUrl) {
        return [];
    }

    try {
        const result = await axios(
            transcriptUrl
        );
        return result.data.items.map(word => ({...word, start_time: Number(word.start), end_time: Number(word.end)}))
    } catch (e) {
        toast.error('Error loading transcripts');
        return null
    }

}
